import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import CCTextInput from '@/Atoms/CCTextInput';
import Empty from '@/Atoms/Empty';
import SlideModal from '@/Atoms/SlideModal';
import Spacer from '@/Atoms/Spacer';
import CCColors from '@/Utils/CCColors';
import {vs, FontSizes} from '@/Utils/Dimensions';
import React, {useEffect, useMemo, useState} from 'react';
import {ScrollView} from 'react-native';
import BookCard from '../BookCard';
import UploadBook from '../UploadBook';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import {AssignmentProps} from './types';
import {useFocusEffect} from '@react-navigation/native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import CCLoader from '@/Atoms/CCLoader';

function Assignment({
  search,
  searchTerm,
  setSearchTerm,
  booksList,
  emptyResult,
  emptyBook,
  upload,
  setBookType,
  openDrawer,
  setOpenDrawer,
  importSuccess,
  userData,
  userId,
  orderBook,
  booksListLoading,
  banner,
}: AssignmentProps) {
  const {isMobileOrTab} = useMediaQuery();
  const [bookList, setBookList] = useState<any>();
  const [showCompletedBooks, setShowCompletedBooks] = useState(false);

  const booksListFormatted = useMemo(() => {
    if (!searchTerm || searchTerm.trim() === '') {
      return booksList?.map(i => ({
        ...i,
        book: i?.name,
        paid: !Number(i?.price) ? true : i?.paid,
        book_price: i?.price,
        book_mrp: i?.mrp,
        type: 'circlechess',
      }));
    }

    const filteredBooks = booksList?.filter(i =>
      i?.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    return filteredBooks?.map(i => ({
      ...i,
      book: i?.name,
      paid: !Number(i?.price) ? true : i?.paid,
      book_price: i?.price,
      book_mrp: i?.mrp,
      type: 'circlechess',
    }));
    // id
    // book
    // progress
    // chapters
    // positions
    // type?
    // book_price?
    // book_mrp?
    // paid?
    // userData?
    // userId?
    // orderBook?
  }, [booksList, searchTerm]);

  const solvedBooksCount = useMemo(() => {
    return booksListFormatted?.filter(book => book?.completed)?.length || 0;
  }, [booksListFormatted]);

  const incompleteBooks = useMemo(() => {
    return booksListFormatted?.filter(book => !book?.completed) || [];
  }, [booksListFormatted]);

  const completedBooks = useMemo(() => {
    return booksListFormatted?.filter(book => book?.completed) || [];
  }, [booksListFormatted]);

  const onSearch = (searchText: string) => {
    setSearchTerm(searchText);
    if (!searchText) {
      setBookList(booksList);
    }
  };

  return (
    <ScrollView
      style={{padding: isMobileOrTab ? 0 : 20, margin: isMobileOrTab ? 10 : 0}}
      showsVerticalScrollIndicator={false}>
      {banner}
      {/* <Spacer spacing={vs(36)} /> */}
      <Box
        {...(!isMobileOrTab && {type: 'row-center-between'})}
        // type="row-center-between"
        style={isMobileOrTab ? {flexDirection: 'column'} : {}}>
        <Box
          // type="row-flex-start"
          {...(!isMobileOrTab && {type: 'row-flex-start'})}
          style={
            isMobileOrTab
              ? {flexDirection: 'row', justifyContent: 'space-between'}
              : {}
          }>
          <CCText fontSize={FontSizes[24]} color={CCColors.Primary.Dark}>
            My Assignments
          </CCText>
          {userData?.is_staff && isMobileOrTab && (
            <CCButton
              icon={upload}
              titleStyle={{color: CCColors.TextColor.Dark}}
              style={{backgroundColor: CCColors.Primary.Action}}
              onPress={() => setOpenDrawer(true)}>
              Upload
            </CCButton>
          )}
        </Box>
        {isMobileOrTab && <Spacer spacing={20} />}
        <Box type={isMobileOrTab ? 'row-center-between' : 'row-flex-start'}>
          <CCTextInput
            icon={search}
            fontSize={14}
            value={searchTerm}
            style={{
              width: isMobileOrTab ? '100%' : 300,
              height: 40,
              backgroundColor: CCColors.White,
              overflow: 'hidden',
            }}
            autoFocus={searchTerm.length}
            placeholder="Search an assignment"
            onChangeText={text => {
              setSearchTerm(text);
              onSearch(text);
            }}
            placeholderTextColor={CCColors.TextColor.Grey}
          />
          {userData?.is_staff && !isMobileOrTab && (
            <>
              <Spacer spacing={vs(36)} horizontal />
              <CCButton
                icon={upload}
                titleStyle={{color: CCColors.TextColor.Dark}}
                style={{backgroundColor: CCColors.Primary.Action}}
                onPress={() => setOpenDrawer(true)}>
                Upload Book
              </CCButton>
            </>
          )}
          {/* <Spacer spacing={vs(10)} horizontal />
          <CCButton
            icon={discover}
            onPress={() => setBookType('books')}
            titleStyle={{color: CCColors.TextColor.Dark}}>
            Discover Books
          </CCButton> */}
        </Box>
      </Box>
      <Spacer spacing={vs(isMobileOrTab ? 20 : 36)} />
      {booksListLoading ? (
        <CCLoader loading bgWhite isComponentLoader />
      ) : (
        <>
          {incompleteBooks.length > 0 || completedBooks.length > 0 ? (
            <>
              {incompleteBooks.length > 0 && (
                <Box
                  flexWrap={isMobileOrTab ? undefined : 'wrap'}
                  gap={isMobileOrTab ? 16 : 20}>
                  {[...incompleteBooks]
                    .sort(
                      (a, b) =>
                        new Date(b.create_timestamp).getTime() -
                        new Date(a.create_timestamp).getTime(),
                    )
                    .map((book, index) => (
                      <BookCard
                        key={book.id || index}
                        {...book}
                        // id={i}
                        index={index}
                        userData={userData}
                        userId={userId}
                        orderBook={orderBook}
                        progress={
                          book?.chapter_details?.filter(ch => ch.solved)
                            ?.length / book?.chapter_details?.length
                        }
                        bookDetails={book}
                      />
                    ))}
                </Box>
              )}
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginTop: 24,
                  marginBottom: 14,
                }}
                onPress={() => setShowCompletedBooks(prev => !prev)}>
                <CCText
                  fontSize={FontSizes[16]}
                  color={CCColors.Green}
                  style={{marginRight: 8}}>
                  Completed Assignments ({solvedBooksCount})
                </CCText>
                <Icon
                  name={showCompletedBooks ? 'chevron-up' : 'chevron-down'}
                  size={24}
                  color={CCColors.Green}
                />
              </Box>
              {(completedBooks.length > 0 || showCompletedBooks) && (
                <>
                  {showCompletedBooks && completedBooks.length > 0 && (
                    <Box
                      flexWrap={isMobileOrTab ? undefined : 'wrap'}
                      gap={isMobileOrTab ? 16 : 20}>
                      {[...completedBooks]
                        .sort(
                          (a, b) =>
                            new Date(b.create_timestamp).getTime() -
                            new Date(a.create_timestamp).getTime(),
                        )
                        .map((book, index) => (
                          <BookCard
                            key={book.id || index}
                            {...book}
                            // id={i}
                            index={index}
                            userData={userData}
                            userId={userId}
                            orderBook={orderBook}
                            progress={
                              book?.chapter_details?.filter(ch => ch.solved)
                                ?.length / book?.chapters
                            }
                            bookDetails={book}
                          />
                        ))}
                    </Box>
                  )}
                </>
              )}
            </>
          ) : (
            !booksListFormatted?.length && (
              <Empty
                imgSrc={searchTerm?.length ? emptyResult : emptyBook}
                title={
                  searchTerm?.length ? 'No results found' : 'No books found'
                }
                description={
                  searchTerm?.length
                    ? `We couldn’t find any assignment matching ”${searchTerm}”
              Try again with another assignment name.`
                    : 'You can discover and buy from our collection of chess books or upload your own with the .pgn format'
                }>
                <Box type="row-flex-start">
                  {userData?.is_staff && (
                    <CCButton
                      icon={upload}
                      titleStyle={{color: CCColors.TextColor.Dark}}
                      style={{backgroundColor: CCColors.Primary.lightBrown}}
                      onPress={() => {
                        setOpenDrawer(true);
                      }}>
                      Upload
                    </CCButton>
                  )}
                  {/* <Spacer spacing={vs(10)} horizontal />
            <CCButton
              icon={discover}
              onPress={() => {
                setBookType('books');
              }}
              titleStyle={{color: CCColors.TextColor.Dark}}>
              Discover Books
            </CCButton> */}
                </Box>
              </Empty>
            )
          )}
        </>
      )}
      <SlideModal
        type="side"
        width={0.3}
        modalHeaderTitle={'Upload assignment'}
        visible={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
        }}>
        <UploadBook
          uploadType={'assignment'}
          buttonName={'Upload Assignment'}
          importSuccess={importSuccess}
          isMobileOrTab={isMobileOrTab}
        />
      </SlideModal>
    </ScrollView>
  );
}

export default Assignment;
